// REAVERFIT — CLS Optimization for PDP
// Prevents layout shifts by pre-allocating space and optimizing load sequence

(function() {
  'use strict';

  // Only run on product pages
  if (!document.body.classList.contains('template-product')) return;

  // 1. Pre-allocate space for dynamic content
  function preallocateSpace() {
    // Reserve space for variant picker if it exists
    const variantPicker = document.querySelector('.variant-picker, [data-variant-picker]');
    if (variantPicker && !variantPicker.style.minHeight) {
      variantPicker.style.minHeight = '60px';
    }

    // Reserve space for buy buttons
    const buyButtons = document.querySelector('.buy-buttons, .product-form__buttons');
    if (buyButtons && !buyButtons.style.minHeight) {
      buyButtons.style.minHeight = '60px';
    }

    // Reserve space for product badges
    const badges = document.querySelector('.badge-list, .product-badges');
    if (badges && !badges.style.minHeight) {
      badges.style.minHeight = '30px';
    }
  }

  // 2. Optimize font loading to prevent text shifts
  function optimizeFontLoading() {
    // Add font-display: swap if not already defined
    if (!document.querySelector('style[data-font-display]')) {
      const style = document.createElement('style');
      style.setAttribute('data-font-display', 'true');
      style.textContent = `
        @font-face {
          font-family: 'Work Sans';
          font-display: swap;
        }
      `;
      document.head.appendChild(style);
    }
  }

  // 3. Prevent accordion/collapse shifts
  function stabilizeAccordions() {
    const accordions = document.querySelectorAll('[data-accordion], .accordion, .collapsible-content');
    accordions.forEach(accordion => {
      accordion.style.transition = 'height 0.3s ease';
    });
  }

  // 4. Stabilize image dimensions early
  function stabilizeImages() {
    const productImages = document.querySelectorAll('.product__media img, .product-gallery img');
    productImages.forEach(img => {
      if (!img.style.aspectRatio && img.dataset.aspectRatio) {
        img.style.aspectRatio = img.dataset.aspectRatio;
      }
      // Add loading=eager for above-fold product images
      if (!img.loading) {
        img.loading = 'eager';
      }
    });
  }

  // 5. Early DOM stabilization
  function earlyStabilization() {
    // Add contain: layout to known shifting elements
    const shiftingElements = document.querySelectorAll(
      '.product-info, .product-form, .variant-picker, .buy-buttons, ' +
      '.product-badges, .product__media, .announcement-bar'
    );
    
    shiftingElements.forEach(el => {
      if (!el.style.contain) {
        el.style.contain = 'layout';
      }
    });
  }

  // Execute optimizations immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      preallocateSpace();
      optimizeFontLoading();
      stabilizeAccordions();
      stabilizeImages();
      earlyStabilization();
    });
  } else {
    preallocateSpace();
    optimizeFontLoading();
    stabilizeAccordions();
    stabilizeImages();
    earlyStabilization();
  }

  // Monitor for late-loading content that might cause shifts
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Apply containment to new elements
            if (node.classList && (
              node.classList.contains('product-info__block') ||
              node.classList.contains('variant-picker') ||
              node.classList.contains('buy-buttons')
            )) {
              node.style.contain = 'layout';
            }
          }
        });
      }
    });
  });

  // Observe changes in the product form area
  const productForm = document.querySelector('.product-form, .product__info');
  if (productForm) {
    observer.observe(productForm, {
      childList: true,
      subtree: true
    });
  }

})();
